import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { saveCoverageDate } from '../../../shared/reducers/enrollment.reducer';
//import * as moment from 'moment';
import moment from 'moment';
import { StateStructure } from '@ptl/state';
import { NgRedux, select } from '@ptl/angular-redux-store';
import { FormConfigUtilityService } from '../services/filterByConfigMetatags/form-config-utility.service';
import { Observable, Subscription } from 'rxjs';
import { DefaultFormConfig } from '@ptl/forms';
import { PlanUtilityService } from '../../plan-selection/plan-summary-list/plan-utility.service';
import { PlanAttributes, SummaryView } from '../../plan-selection/interfaces/plan-attributes.interface';
import { Product } from '../../plan-selection/interfaces/product.interface';
import { DateService } from '../../../shared/services/date.service';
import { IndividualPlanEnrollmentService } from './individual-plan-enrollment-form/page-individual-plan-enrollment/services/individual-plan-enrollment.service';
import { APPLICANT_RELATION } from '../../plan-selection/services/interfaces/shared/plan-demographics/applicant.interface';
import { SAVED_QUOTES_REDUCER_NAME, saveEnrollmentFlow } from '../../producer/saved-quotes/reducers/saved-quotes.reducer';
import { SavedQuotesStateStructure } from '../../producer/saved-quotes/interfaces/savedQuotesStateStructure.interface';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';

enum SPOUSE_RELATIONSHIP {
  SPOUSE = APPLICANT_RELATION.SPOUSAL_PARTNER,
  DOMESTIC_PARTNER = APPLICANT_RELATION.DOMESTIC_PARTNER
}

@Component({
    selector: 'app-plan-enrollment',
    templateUrl: './plan-enrollment.component.html',
    styleUrls: ['./plan-enrollment.component.scss'],
    standalone: false
})
export class PlanEnrollmentComponent implements OnInit, OnDestroy {

  @select(['componentStates', 'Plans', 'activeProductGroup']) activeProductGroup$: Observable<string>;
  @select(['componentStates', 'ZipCounty']) zipCounty$: Observable<string>;
  @select(['componentStates', 'Plans', 'planIdForEnrollment']) planIdForEnrollment$: Observable<string>;
  @select(['payloadStates', 'enrollment', 'coverageDate']) coverageDate$: Observable<string>;
  @select(['payloadStates', 'personalInfo', 'gender']) gender$: Observable<string>;
  @select(['payloadStates', 'personalInfo', 'dob']) dob$: Observable<string>;

  spousalPartnerRelationshipSubscription: Subscription;
  @select(['payloadStates', 'individualMarket', 'ratingInfo', 'spousal-partner', '0', 'relationship']) spousalPartnerRelationship$: Observable<SPOUSE_RELATIONSHIP>;

  @Input() confirmationPageUrl: string;
  @Input() saveForLaterPageUrl: string;
  @Input() medigapConfirmationPageUrl: string;
  @Input() whbConfirmationPageUrl: string;
  @Input() pdpConfirmationPageUrl: string;
  @Input() registrationUrl: string;
  @Input() forgotPasswordUrl: string;
  @Input() isReviewOnly = false;

  // TODO: INDIVIDUAL: Why do we need this here?
  @Input() summaryText: string;

  formJson: DefaultFormConfig; // EnrollmentFormConfig; // json.formConfiguration;

  pagesAddedReadyToDisplay: boolean;

  constructor(
    private formConfigUtilityService: FormConfigUtilityService,
    private ngRedux: NgRedux<StateStructure>,
    private reducerUtilityService: ReducerUtilityService,
    private planUtilityService: PlanUtilityService,
    private dateService: DateService,
    private individualPlanEnrollmentService: IndividualPlanEnrollmentService
  ) { }


  ngOnDestroy(): void {
    this.spousalPartnerRelationshipSubscription?.unsubscribe();

  }
  async ngOnInit() {

    const coverageDate = this.reducerUtilityService.getGlobalStateItem('payloadStates.enrollment.coverageDate');
    if (coverageDate) {
      this.ngRedux.dispatch(saveCoverageDate(moment(coverageDate).toISOString()));
    }

    // TODO - this should use a subscription to pull the content map. This WILL fail if the
    // content storage compoment is placed on the AEM page below the form component
    this.formJson = await this.formConfigUtilityService.getFormConfigFromMap('enrollment');

    /** For individual flow, don't load the form until the dynamic pages have been added */
    if (this.formJson?.meta?.market?.toUpperCase() === 'INDIVIDUAL') {
      // TODO: in the future remove this and simplify to configuration.
      this.formJson = await this.individualPlanEnrollmentService.configureNonSubscriberPages(this.formJson);
      const savedQuotesState: SavedQuotesStateStructure = this.reducerUtilityService.getState(SAVED_QUOTES_REDUCER_NAME);
    
      if (savedQuotesState?.enrollmentFlow == null){
        this.ngRedux.dispatch(saveEnrollmentFlow(this.formJson.form.customConfigs.enrollmentFlow));
      }
      this.pagesAddedReadyToDisplay = true;
    } else {
      this.pagesAddedReadyToDisplay = true;
    }

    if (this.isReviewOnly) {
      // Page type is based off of the registered component names which shouldn't change
      // however, when we dynamically add pages (ala Individual spouse/dependent) this is untrue
      const reviewIndex = this.formJson.pages.findIndex(page => page.pageType.toLowerCase().indexOf('review') !== -1);

      // remove Medicare applicant review submit component
      if (this.formJson.pages[reviewIndex].custom?.reviewEntries){
        this.formJson.pages[reviewIndex].custom.reviewEntries = [];
      }

      this.formJson.form.formHeader.showStepper = false;

      if (!this.formJson.form.customConfigs) {
        this.formJson.form.customConfigs = {};
      }

      this.formJson.form.customConfigs.reviewOnly = true;
    }

    /** Make sure that any existing custom configs are carried over */
    this.formJson.form.customConfigs = Object.assign({}, {
      confirmationPageUrl: this.confirmationPageUrl,
      saveForLaterPageUrl: this.saveForLaterPageUrl,
      medigapConfirmationPageUrl: this.medigapConfirmationPageUrl,
      whbConfirmationPageUrl: this.whbConfirmationPageUrl,
      pdpConfirmationPageUrl: this.pdpConfirmationPageUrl,
      registrationUrl: this.registrationUrl,
      forgotPasswordUrl: this.forgotPasswordUrl
    }, this.formJson.form.customConfigs);

    // TODO: INDIVIDUAL: Why are we doing this here???
    const notificationPageIndex = this.formJson.pages.findIndex(page => page.pageHeader === 'Notifications & Authorizations' || 'Producer Attestation');

    if (notificationPageIndex > -1) {
      let i = 0;
      for (const entry of this.formJson.pages[notificationPageIndex].entries) {
        if (entry.formControlAttributes && this.summaryText !== undefined &&
          entry.formControlAttributes.formControlName === 'planSummary') {

          this.formJson.pages[notificationPageIndex].entries[i].base.text = this.summaryText;
        }

        i++;
      }
    }

    this.activateStringReplacementForEntries();
    this.observeSpecificChanges();
  }

  observeSpecificChanges() {
    
    /** Individual Market specific - adds an attestation page for domestic partnerships where needed */
    this.spousalPartnerRelationshipSubscription
      = this.spousalPartnerRelationship$.subscribe( (v: SPOUSE_RELATIONSHIP) => {
        const shouldShowAttestation = v === SPOUSE_RELATIONSHIP.DOMESTIC_PARTNER;
        this.formJson = this.individualPlanEnrollmentService.toggleDomesticPartnerAttestationPage(this.formJson, shouldShowAttestation);
      })
  }

  activateStringReplacementForEntries() {
    this.formJson.replacementMap = {};

    this.zipCounty$.subscribe((value: any) => {
      if (value.county) {
        this.formJson.replacementMap['<<personInfoZipCode>>'] = value?.zipCode;
        this.formJson.replacementMap['<<personInfoCounty>>'] = value?.county?.county;
        this.formJson.replacementMap['<<personInfoState>>'] = value?.county?.state;
      }
    });

    this.coverageDate$.subscribe(value => this.formJson.replacementMap['<<coverageDate>>'] = (value && this.dateService.getDateAsFormattedString(value, 'MM/DD/YYYY')));
    this.dob$.subscribe(value => this.formJson.replacementMap['<<dateOfBirth>>'] = (value && this.dateService.getDateAsFormattedString(value, 'MM/DD/YYYY')));

    this.gender$.subscribe((value) => {
      let gender = '';

      if (value === 'M') {
        gender = 'Male';
      }
      else if (value === 'F') {
        gender = 'Female';
      }

      this.formJson.replacementMap['<<gender>>'] = gender;
    });

    this.planIdForEnrollment$.subscribe(value => {
      if (value) {
        const plansFromState = this.planUtilityService.getPlansByProductGroupAsArray();
        if (plansFromState.length > 0) {
          const selectedPlan: Product<PlanAttributes, SummaryView> =
            plansFromState.filter(plan => plan.attributes.PLAN_ID === value)[0];

          /** Product Info */
          if (selectedPlan.attributes) {
            this.formJson.replacementMap['<<planName>>'] = selectedPlan.attributes.PRODUCT_NAME;

            if (typeof selectedPlan.price === 'number') {
              this.formJson.replacementMap['<<planPrice>>'] = selectedPlan.price && (Math.round(selectedPlan.price * 100) / 100).toFixed(2).toString();
            }
          }
        }
      }
    });
  }

}
